<template>
  <div>
    <div v-if="company" class="company-info">
      
      <!-- <div class="header">
        <div v-if="$route.meta.model !=='companies' " class="hover company-link" @click="$router.push('/companies/'+company.id)">
          <h5>Карточка компании</h5>
        </div>
      </div> -->
      
      <div class="company-base-information">
        <div class="company-user-info">
          <my-input-form :form="{
              id:company.id,
              name:'name',
              title:'Название:',
              value:company.name,
              model
            }"
            class="info-item">
            Название: 
          </my-input-form>
          <my-input-form class="small-size" :form="{
              id:company.id,
              name:'director',
              title:'Директор:',
              value:company.director,
              model
            }">
            Директор: 
          </my-input-form>
          <my-input-form :form="{
              id:company.id,
              name:'ogrn',
              title:'ОГРН:',
              value:company.ogrn,
              model
            }">
            ОГРН: 
          </my-input-form>
          <my-input-form :form="{
              id:company.id,
              name:'inn',
              title:'ИНН:',
              value:company.inn,
              model
            }">
            ИНН: 
          </my-input-form>
        </div>
        <div class="chart-user-info" >
          <LineCompanyChart 
            class="chart" 
            v-if="datasets && settings.chart" 
            :data="datasets"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanySecurityInfo from '@/pages/securityCheck/components/CompanySecurityInfo.vue'
import LineCompanyChart from '@/components/charts/LineCompanyChart'
import { computed } from 'vue'
import { useStore } from 'vuex'


export default {
  name: 'CompanyInfo',
  props: ['company','settings','chart'],
  components:{
    CompanySecurityInfo,
    LineCompanyChart
  },
  setup(props){
    const store = useStore()
    const datasets = !props.chart ? computed(()=>store.getters[props.settings.source]) : [];

    return{
      datasets,
      model:'companies'
    }
  }
};
</script>

<style scoped>
.company-info {

}

.company-info h3 {
  font-size: 20px;
  font-weight: bold;
}

.company-info p {
  margin: 5px 0;
}

.company-info p:first-child {
  margin-top: 0;
}

.status-company{
  display: flex;
  align-items: center;
  margin: 10px 0;
}

.status-content{
  margin-left: 10px;
}

.company-base-information{
  display: flex;
  align-items: center;
}

.company-user-info{
  text-align: left;
  min-width: 260px;
}

.small-size{
  font-size: 14px;
}
.hover:hover{
  cursor: pointer;
  background-color: rgba(207,207,208,1);
}
.company-link{
  padding: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.header{
  display: flex;
  justify-content: flex-start;
}
</style>
